import { render, staticRenderFns } from "./HoldResultModal.vue?vue&type=template&id=4a8bee74"
import script from "./HoldResultModal.vue?vue&type=script&lang=js"
export * from "./HoldResultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports